const CompetitionPageReducer = (state, action) => {
  switch (action.type) {
    case 'COMPETITION_DEFAULT_AGE_GROUPS_FETCHING':
      return {
        ...state,
        ageGroups: {...state.ageGroups, isFetching: true},
      };
    case 'COMPETITION_DEFAULT_AGE_GROUPS_UPDATE':
      const {items, openAgeGroup} = action.data;
      return {...state, ageGroups: {isFetching: false, items}, openAgeGroup};
    case 'OPEN_AGE_GROUP_UPDATE':
      return {...state, openAgeGroup: action.key};
    case 'COMPETITION_DEFAULT_COMPETITIONS_FETCHING':
      return {
        ...state,
        competitions: {...state.competitions, isFetching: true},
      };
    case 'COMPETITION_DEFAULT_COMPETITIONS_UPDATE':
      return {
        ...state,
        competitions: {
          ...state.competitions,
          isFetching: false,
          [action.data.key]: action.data.items,
        },
      };
    case 'COMPETITION_DEFAULT_COMPETITIONS_ERROR':
      return {
        ...state,
        competitions: {
          ...state.competitions,
          isFetching: false,
          error: action.data,
        },
      };
    default:
      return state;
  }
};

const initData = {
  ageGroups: {
    isFetching: false,
    items: [],
  },
  openAgeGroup: null,
  competitions: {
    isFetching: false,
    error: null,
  },
};

export {CompetitionPageReducer, initData};
